import React from 'react';
import moment from 'moment-timezone';
import { Card, Button } from 'react-bootstrap';
import { DISPLAY_DATE_FORMAT2 } from '../../constants';

const LoadTripCard = ({ trip, selected, onClickWorkWindow }) => <Card>
    <div className="card-left-box">
        <div className="visit-number">
            {trip.visit_id}
        </div>
        <div className="visit-label">
            Visit
        </div>
    </div>
    <Card.Body>
        <div className="visit-date">
            {moment.utc(trip.farm_day).format(DISPLAY_DATE_FORMAT2)}
        </div>
        <Button
            size="sm"
            variant={selected ? 'warning' : 'outline-primary'}
            className="mt-2"
            onClick={onClickWorkWindow}>
            View work window
        </Button>
    </Card.Body>
</Card>;

export default LoadTripCard;